const AppFieldTitleConfig = {
    fontColor: {
        gray: "gray",
        black: "black"
    },
    compulsory: {
        true: "true",
        false: "false"
    }
}

export default AppFieldTitleConfig